import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class FoamCenterInstallationDto extends InspectionCase {
  equipmentInstalledAsDesigned?: InspectionCase;
  dosageUnitType?: InspectionCase;
  concentrationTankVolumeAsDesigned?: InspectionCase;
  concentrationDetails?: InspectionCase;
  installationAccordingPlans?: InspectionCase;
  concentratePipingAsRequired?: InspectionCase;
  solutionPipeGalvanized?: InspectionCase;
  foamCenterAtShadedArea?: InspectionCase;
}

export class FoamCenterInstallation extends FoamCenterInstallationDto {
  constructor(data: FoamCenterInstallationDto = { title: 'מרכז קצף' }) {
    super(data);
    this.equipmentInstalledAsDesigned = new InspectionCase({
      ...data.equipmentInstalledAsDesigned,
      title:
        'הציוד שהותקן בשטח מתאים לתכנון המאושר (וודא התאמה מול דפי הקטלוג שהוגשו ואושרו בשלב התכנון)'
    });
    this.dosageUnitType = new InspectionCase({
      ...data.dosageUnitType,
      title: 'פרט את סוג יחידת המינון'
    });
    this.concentrationTankVolumeAsDesigned = new InspectionCase({
      ...data.concentrationTankVolumeAsDesigned,
      title: 'נפח מיכל התרכיז תואם לדרישות התכנון, פרט'
    });
    this.concentrationDetails = new InspectionCase({
      ...data.concentrationDetails,
      title: `וודא פרטי התרכיז ( תאריך מילוי, סוג, מס' קטלוגי/ סידורי)`
    });
    this.installationAccordingPlans = new InspectionCase({
      ...data.installationAccordingPlans,
      title: 'ההתקנה בוצעה בהתאם לתוכניות מאושרות וע"פ הוראות היצרן'
    });
    this.concentratePipingAsRequired = new InspectionCase({
      ...data.concentratePipingAsRequired,
      title: 'צנרת התרכיז שחורה/נירוסטה ובעובי דופן לפי תפריט sch-40'
    });
    this.solutionPipeGalvanized = new InspectionCase({
      ...data.solutionPipeGalvanized,
      title: 'צנרת התמיסה מגולוונת'
    });
    this.foamCenterAtShadedArea = new InspectionCase({
      ...data.foamCenterAtShadedArea,
      title: 'מרכז הקצף (מיכל התרכיז) ממוקמים באזור מוצל ואינו סמוך לאזור האש'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.equipmentInstalledAsDesigned.isApplicable ||
        this.equipmentInstalledAsDesigned.isPassed) &&
        (!this.dosageUnitType.isApplicable || this.dosageUnitType.isPassed) &&
        (!this.concentrationTankVolumeAsDesigned.isApplicable ||
          this.concentrationTankVolumeAsDesigned.isPassed) &&
        (!this.concentrationDetails.isApplicable ||
          this.concentrationDetails.isPassed) &&
        (!this.installationAccordingPlans.isApplicable ||
          this.installationAccordingPlans.isPassed) &&
        (!this.concentratePipingAsRequired.isApplicable ||
          this.concentratePipingAsRequired.isPassed) &&
        (!this.solutionPipeGalvanized.isApplicable ||
          this.solutionPipeGalvanized.isPassed) &&
        (!this.foamCenterAtShadedArea.isApplicable ||
          this.foamCenterAtShadedArea.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.equipmentInstalledAsDesigned.getNotes(),
      ...this.dosageUnitType.getNotes(),
      ...this.concentrationTankVolumeAsDesigned.getNotes(),
      ...this.concentrationDetails.getNotes(),
      ...this.installationAccordingPlans.getNotes(),
      ...this.concentratePipingAsRequired.getNotes(),
      ...this.solutionPipeGalvanized.getNotes(),
      ...this.foamCenterAtShadedArea.getNotes()
    ];
  }
}
